export enum ImageType {
  Icon = 'Icon',
  HeaderIcon = 'HeaderIcon',
  MenuIcon = 'MenuIcon',
  Background = 'Background',
}
